export abstract class Source {
    private _dirty = true;

    protected setDirty() {
        this._dirty = true;
    }

    isDirty() {
        return this._dirty;
    }

    clearDirty() {
        this._dirty = false;
    }

    abstract hasData(): boolean;
}
